import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, User, Calendar } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/blog/by-slug/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-4xl mb-4">Artigo não encontrado</h1>
      <Link to="/blog" className="btn-outline-gold text-sm border-[color:var(--marupiara-gold-dark)] text-[color:var(--marupiara-gold-dark)]">Ver blog</Link>
    </div>
  );
  if (!post) return <div className="py-32 text-center">Carregando…</div>;

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <article>
        <div className="max-w-3xl mx-auto px-6 py-16">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[color:var(--marupiara-gold-dark)] mb-8"><ArrowLeft size={14} /> Voltar ao blog</Link>
          <div className="overline text-[color:var(--marupiara-gold-dark)] mb-4">{post.category}</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.1] text-[color:var(--marupiara-obsidian)] mb-6">{post.title}</h1>
          <div className="flex gap-4 text-sm text-[color:var(--marupiara-text-on-light-muted)] mb-8">
            <span className="flex items-center gap-1"><User size={14} /> {post.author}</span>
            {post.published_at && <span className="flex items-center gap-1"><Calendar size={14} /> {new Date(post.published_at).toLocaleDateString("pt-BR")}</span>}
          </div>
          {post.cover_url && <img src={post.cover_url} alt={post.title} className="w-full aspect-[16/9] object-cover mb-10" />}
          <div className="prose-editorial text-neutral-800" dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      </article>
    </div>
  );
}
